import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/ashar-merac-logo.png"
          width="auto"
          height="100%"
          loading="lazy"
          alt="House of Hiranandani"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        With a legacy of excellence spanning over two decades, Ashar Group has
        established itself as one of Mumbai's most trusted real estate
        developers. Known for delivering quality projects on time, Ashar Group
        has successfully developed residential, commercial, and IT spaces that
        cater to the evolving needs of modern urban dwellers. Ashar Merac is yet
        another testament to their commitment to creating spaces that offer a
        harmonious blend of luxury, comfort, and convenience.
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/rera-P51700056361.jpeg" alt="rera qr" />
          <strong>P51700056361</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
